import GroupedBar from 'd3vue/components/GroupedBar.vue'
import { keepDimensions, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toScale } from '../colors'
import api from '../api'
import * as d3 from 'd3'

export default {
  id: 'grouped-bar',
  label: 'Graphique en barre groupées',
  component: GroupedBar,
  dimensions: 2,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    const props = {}
    if (vue.colorScheme) {
      props.color = toScale(vue.colorScheme)
    }
    vue.buildProps(props)
    return buildCropFunction(d => d.y, vue)(keepDimensions(2, data).map(d => {
      return {
        data: d,
        x: d.Group0Caption,        
        y: valueAsNumber(d[api.measure.name(vue.measure[0])]),
        z: d.Group1Caption
      }
    }).filter(d => !vue.noEmpty || d.y))
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/GroupedBar.js